export default "__VITE_ASSET__DhKcwunw__"